export const GET_TEAM_FIRMS_QUERY = `
  query GetTeamFirms($where: team_firms_bool_exp = {}) {
    team_firms(where: $where, order_by: { created_at: desc }) {
      id
      team_id
      firm_id
      company_id
      created_at
      team {
        id
        name
      }
      firm {
        id
        firm_name
        firm_short_name
        firm_city
      }
    }
  }
`;

export const GET_TEAM_FIRMS_BY_TEAM_QUERY = `
  query GetTeamFirmsByTeam($teamId: Int!) {
    team_firms(where: { team_id: { _eq: $teamId } }, order_by: { created_at: desc }) {
      id
      firm_id
      firm {
        id
        firm_name
        firm_short_name
        firm_city
      }
    }
  }
`;
